import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Header, {headerItemsLabels} from '../../Common/Header/header';
import useLabels from 'infrastructure/js/hooks/useLabels';
import CocTestsViewGrid from '../CoCTestsViewGrid/cocTestsViewGrid';
import UnitHelper, {unitTypes} from 'infrastructure/js/utils/uomHelper';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import ProgressIndicator from 'infrastructure/js/components/ProgressIndicator/progressIndicator';
import NameValuePairs from '../../Common/NameValuePairs/nameValuePairs';
import PermissionManager from 'infrastructure/js/utils/permissionManager';

import './cocView.scss';


export default function CocView ({ history,
                                   match,
                                   initialData=null,
                                   actions,
                                  }) {

  const labels = useLabels('mat.views.coc.');

  const [cocDetails, setCoCDetails] = useState([]);


  useEffect(() => {
    const details = [
      { label: labels.get('material'), value: initialData.material?.materialName ?? ''},
      { label: labels.get('quantity'), value: UnitHelper.serverValueToUserValueWithLabel(PermissionManager.isWeightSupported() ? unitTypes.WEIGHT : unitTypes.LENGTH, initialData.quantity ?? 0)},
      { label: labels.get('qplVersion'), value: `${initialData?.qplVersion} (${DateTimeHelper.DateTimeFormat(initialData.qplLastUpdated?.epochDateTime * 1000)})`},
      { label: labels.get('lastUpdate'), value: DateTimeHelper.DateTimeFormat(initialData.cocLastUpdated?.epochDateTime * 1000)},
      { label: labels.get('customerSpecs'), value: initialData.customerSpecs || 'N/A'},
    ];

    setCoCDetails(details);

  }, [initialData]);

  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.cocViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.cocViewActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
      ]
    }
  }

  const getProgressIndicatorItems = () => {
    return [
      {
        color: '#02ce6c',
        name: labels.get('indicator.passed'),
        value: initialData?.passedTestsCount
      },
      {
        color: '#e03a62',
        name: labels.get('indicator.failed'),
        value: initialData?.failedTestsCount
      },
      {
        color: '#C7C7C7FF',
        name: labels.get('indicator.notFilled'),
        value: initialData?.pendingTestsCount
      },

    ]
  }


  return initialData ? (
    <div className="coc-view">

      <div className='coc-details-section'>
        <NameValuePairs items={cocDetails} />
      </div>

      <div className='coc-status-section'>
        <NameValuePairs items={[{label: labels.get('indicator.allTests'), value: initialData?.testsCount ?? 0}]} />
        <ProgressIndicator items={getProgressIndicatorItems()}/>

        <Header {...getHeaderItems()}/>
      </div>

      <div className='coc-tests-section'>
        <CocTestsViewGrid
          actions={actions.cocTestsViewGridActions}
          history={history}
          match={match}/>
      </div>

    </div>
  ) : null;
}


  CocView.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    initialData: PropTypes.object,
    actions: PropTypes.object.isRequired,
};
